import { Link } from "react-router-dom";
import { Heart, Eye } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { catName } from "@/lib/categories";
import { mediaUrl } from "@/lib/api";
import { SaveButton } from "@/components/app/SaveButton";

export default function ProjectCard({ project }) {
  const creator = project.creator || {};
  return (
    <Link
      to={`/project/${project.project_id}`}
      className="group relative block rounded-lg overflow-hidden bg-card border border-border/60 card-hover"
      data-testid={`project-card-${project.project_id}`}
    >
      <div className="relative overflow-hidden bg-muted">
        <SaveButton projectId={project.project_id} />
        <img
          src={mediaUrl(project.cover_url) || project.media?.[0]?.url}
          alt={project.title}
          loading="lazy"
          className="w-full h-auto block image-zoom"
          style={{ display: "block" }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
        <div className="absolute inset-x-0 bottom-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="flex items-center gap-2 text-white text-xs font-mono-u uppercase tracking-widest">
            <span className="flex items-center gap-1"><Heart className="h-3 w-3" />{project.like_count || 0}</span>
            <span className="flex items-center gap-1"><Eye className="h-3 w-3" />{project.views || 0}</span>
          </div>
        </div>
      </div>
      <div className="p-3 flex items-center justify-between gap-2">
        <div className="min-w-0">
          <div className="font-display font-semibold text-sm truncate" data-testid="project-title">{project.title}</div>
          <div className="flex items-center gap-1.5 mt-0.5 min-w-0">
            <Avatar className="h-4 w-4"><AvatarImage src={creator.avatar_url} /><AvatarFallback>{creator.username?.[0]}</AvatarFallback></Avatar>
            <span className="text-xs text-muted-foreground truncate">@{creator.username}</span>
          </div>
        </div>
        <span className="meta-label whitespace-nowrap hidden sm:block">{catName(project.category)}</span>
      </div>
    </Link>
  );
}
